export class TicketClosePutRequest {
  ticketId!: string
  version!: number

  constructor(ticketId: string, version: number) {
    this.ticketId = ticketId
    this.version = version
  }
}
